/**
 * Created by valerasiestov on 30.10.15.
 */


if (!window.module) {
    window.module = {};
}

module.listener = (function () {
    "use strict";

    var list = {};

    function add(item) {
        if (!list[item.name]) {
            list[item.name] = item.handler;
        } else {
            console.log('key is exist');
        }
    }

    function exec(key, data) {
        if (list[key]) {
            list[key](data);
        }
    }

    return {
        add: add,
        exec: exec
    };

}());